import React from 'react';
import {ThemeProvider as MuiThemeProvider, Theme, StyledEngineProvider} from '@mui/material/styles';

import {CssBaseline} from '@mui/material';
import {themeContext, useThemeContextBuilder} from 'common/context/ThemeContext';
import {ReactFChildrenProps} from 'types/react/ReactFChildrenProps';

declare module '@mui/styles/defaultTheme' {
   // eslint-disable-next-line @typescript-eslint/no-empty-interface
   interface DefaultTheme extends Theme {}
}

const ThemeProvider: ReactFChildrenProps = ({children}) => {
   const stateTheme = useThemeContextBuilder();
   const [theme] = stateTheme;

   return (
      <StyledEngineProvider injectFirst>
         <MuiThemeProvider theme={theme}>
            <CssBaseline />
            <themeContext.Provider value={stateTheme}>{children}</themeContext.Provider>
         </MuiThemeProvider>
      </StyledEngineProvider>
   );
};

export default ThemeProvider;
